import styled from 'styled-components';
import MuiEditIcon from '@mui/icons-material/Edit';
import { Tooltip } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

interface IAvatarImageProps {
  width: string;
  height: string;
  avatarBase64?: null | string | undefined | number | unknown | Record<string, unknown>;
  avatarUrl?: string;
}
interface IAvatarContainerProps {
  width: string;
  height: string;
  maskWidth: string;
  maskHeight: string;
  maskPositionTop: string;
  maskPositionLeft: string;
}

export const AvatarContainer = styled.div`
  position: relative;
  width: ${(props: IAvatarContainerProps) => props.width};
  height: ${(props: IAvatarContainerProps) => props.height};
  display: inline-block;

  & > svg {
    position: absolute;
    top: ${(props: IAvatarContainerProps) => props.maskPositionTop};
    left: ${(props: IAvatarContainerProps) => props.maskPositionLeft};
    display: block;
    width: ${(props: IAvatarContainerProps) => props.maskWidth};
    height: ${(props: IAvatarContainerProps) => props.maskHeight};
  }

  .hover-mask {
    display: none;
  }

  &:hover .hover-mask {
    display: block;
  }
`;

export const AvatarImage = styled.div`
  width: ${(props: IAvatarImageProps) => props.width};
  height: ${(props: IAvatarImageProps) => props.height};
  background-image: ${(props: IAvatarImageProps) =>
      props.avatarBase64 || props.avatarUrl
        ? props.avatarBase64
          ? `url('data:image;base64,${props.avatarBase64}'),`
          : `url('${props.avatarUrl}'),`
        : ''}
    url('/img/avatar-add.png');
  background-repeat: no-repeat, no-repeat;
  background-size: cover, cover;
  background-position: center, center;
  overflow: hidden;
  position: relative;

  & > img {
    width: ${(props: IAvatarImageProps) => props.width};
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const EditIcon = styled(MuiEditIcon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #354052;
`;

export const HoverMask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
`;

export const AdminStar = styled.img.attrs({
  src: '/img/admin-star.svg',
  alt: '',
})`
  width: 12.6px;
  position: absolute;
  left: 37px;
  top: 3px;
`;
export const RootUserStar = styled.img.attrs({
  src: '/img/rootUser-star.svg',
  alt: '',
})`
  width: 12.6px;
  position: absolute;
  left: 37px;
  top: 3px;
`;
export const CustomizedToolTip = muiStyled(Tooltip)(({ theme }) => ({
  tooltip: {
    backgroundColor: '#ffffff',
    color: '#354052',
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
    boxShadow: '0 0 2px rgba(0,0,0,0.5)',
    width: '90px',
    textAlign: 'center',
  },
  arrow: {
    color: theme.palette.common.white,
    boxShadow: '0 0 2px rgba(0,0,0,0.5)',
    fontSize: 2,
  },
  tooltipPlacementRight: {
    position: 'absolute',
    bottom: '10px',
  },
}));
